import { getToken } from 'utils/auth';
import { bucketUrl } from 'utils/files';

interface IViewerInstance {
  start: (
    arg0: string,
    arg1: {
      document: string;
      env: string;
      api: string;
      accessToken: string;
      language: string;
    },
    onSuccessCallback: () => void
  ) => void;
  prefs: { tag: (arg0: string) => void };
  model: { getInstanceTree: () => void };
  resize: () => void;
  finish: () => void;
  loadSpinner: { innerHTML: string };
  fitToView: () => void;
}

let viewer: IViewerInstance | null;

const cache: string[] = [];

function handleCustomLoader(img?: string) {
  if (img) {
    cache.push(img);
  }

  const image = `${bucketUrl}/${cache[0]}`;
  const newLoader = `<div id="spinner" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 750px; height: 500px; background-image: url(${image}); background-size: contain; background-position: center; background-repeat: no-repeat;"></div>`;
  return newLoader;
}

function handleClearViewer() {
  if (!viewer) return;

  viewer.finish();
  viewer = null;
}

function onSuccessCallback() {
  viewer?.fitToView();
}

function launchViewer(div: string, urn: string) {
  const options = {
    document: urn,
    env: 'Local',
    api: 'streamingV2',
    accessToken: getToken(),
    language: 'en',
  };

  try {
    // This is needed for tests, DO NOT CHANGE!!
    const { Autodesk } = window as any;

    if (!Autodesk) return;

    handleClearViewer();

    Autodesk.Viewing.Initializer(options, () => {
      viewer = new Autodesk.Viewing.GuiViewer3D(document.getElementById(div));
      if (!viewer) return;
      viewer.start(options.document, options, onSuccessCallback);
      viewer.prefs.tag('ignore-producer');
      const image = handleCustomLoader();
      viewer.loadSpinner.innerHTML = image;
    });
  } catch (error) {
    console.error(error);
  }
}

function resizeViewer(div: string) {
  // This is needed for tests, DO NOT CHANGE!!
  const { Autodesk } = window as any;

  if (!Autodesk) return;

  viewer = new Autodesk.Viewing.GuiViewer3D(document.getElementById(div));
  viewer?.resize();
}

export default {
  launchViewer,
  resizeViewer,
  handleCustomLoader,
};
